import BaseCan from "../baseCan"
import User from "../../models/user"
import UserDecorator from "../../../formability/admin/models/userDecorator"
import { OrganizationRoleCapability } from '~/enums/roles/capabilities/organizationRoleCapability';

export default class PublishCan extends BaseCan {
  constructor(user: User | UserDecorator) {
    super(user)

    if (user.is_admin) {
      this.iCan(['unlock'], { displayName: 'document' })
    }

    if (user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels)) {
      this.iCan('publish', { displayName: 'document' });
    }
  }
}
